import {action, computed, observable, makeObservable} from 'mobx';

class UiStore {
  collapsibles = observable.map();

  requestId = 0;
  shouldScrollBeRestored = Promise.resolve(false);
  shouldScrollBeRestoredForNextRoute = false;
  snapshots = {};
  store = null;

  constructor() {
    makeObservable(this);
  }

  @computed
  get currentSnapshot() {
    return this.snapshots[this.store.router.currentPath];
  }

  restoreScroll(fallback) {
    const {currentSnapshot} = this;

    if (currentSnapshot) {
      this.scrollTo(currentSnapshot.scrollX, currentSnapshot.scrollY);
    } else if (typeof fallback === 'function') {
      const {scrollX, scrollY} = fallback();
      this.scrollTo(scrollX, scrollY);
    } else {
      this.scrollTo(0, 0);
    }
  }

  saveScrollFor(path) {
    const {scrollX, scrollY} = window;
    this.snapshots[path] = {scrollX, scrollY};
  }

  setStore(store) {
    this.store = store;
  }

  scrollTo(x, y) {
    if (this.requestId !== 0) {
      window.cancelAnimationFrame(this.requestId);
    }

    this.requestId = window.requestAnimationFrame(() => {
      window.scrollTo(x, y);
    });
  }

  @action
  initCollapsible(id, defaultValue) {
    if (this.collapsibles.get(id) === undefined) {
      this.collapsibles.set(id, defaultValue);
    }
  }

  @action
  toggleCollapsible(id) {
    this.collapsibles.set(id, !this.isCollapsed(id));
  }

  isCollapsed(id) {
    return this.collapsibles.get(id);
  }
}

export default UiStore;
